// Will represent the type of data sent to the backend
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type BaselineMappedDataType = any;

export interface SingleIngredient {
  value: string;
  text: string;
  isSilage?: boolean;
  isMilk?: boolean;
}

export interface Origin {
  value: string;
  text: string;
}

export interface CompoundFeedNameDatabase {
  databaseFoundation: string;
  displayName: string;
  value: string;
  targetSpecies: [string];
}

export interface CoreConnectCompoundFeedNameDatabase {
  display_name: string;
  value: string;
  databaseFoundation: string;
}
export interface AnimalSystemEnumType {
  BROILER_SYSTEM: "BROILER_SYSTEM";
  BEEF_SYSTEM: "BEEF_SYSTEM";
  PIG_SYSTEM: "PIG_SYSTEM";
  MARINE_FISH_SYSTEM: "MARINE_FISH_SYSTEM";
  LAYER_SYSTEM: "LAYER_SYSTEM";
  DAIRY_SYSTEM: "DAIRY_SYSTEM";
  SHRIMP_SYSTEM: "SHRIMP_SYSTEM";
  TURKEY_SYSTEM: "TURKEY_SYSTEM";
}

export const AnimalSystemEnum: AnimalSystemEnumType = {
  BROILER_SYSTEM: "BROILER_SYSTEM",
  BEEF_SYSTEM: "BEEF_SYSTEM",
  PIG_SYSTEM: "PIG_SYSTEM",
  MARINE_FISH_SYSTEM: "MARINE_FISH_SYSTEM",
  LAYER_SYSTEM: "LAYER_SYSTEM",
  DAIRY_SYSTEM: "DAIRY_SYSTEM",
  SHRIMP_SYSTEM: "SHRIMP_SYSTEM",
  TURKEY_SYSTEM: "TURKEY_SYSTEM",
};
